<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="https://www.eastsun.net/eastsunImg/1.png" alt />
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/news">新闻资讯</el-menu-item>
          <el-menu-item index="/product">产品中心</el-menu-item>
          <el-menu-item index="/case">经典案例</el-menu-item>
          <el-menu-item index="/goin">走进东太</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>走进东太</p>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>资质荣誉</span>
              <span>合作伙伴</span>
            </li>
            <li>
              <p>新闻资讯</p>
              <span></span>
              <span>行业动态</span>
              <span></span>
              <span></span>
            </li>
            <li>
              <p>产品中心</p>
              <span>空中课堂平台</span>
              <span>空中课堂App</span>
              <span>治理监测平台</span>
              <span>治理监测APP</span>
            </li>
            <li>
              <p>联系我们</p>
              <span>邮箱：346101875@qq.com</span>
              <span>个人电话：18668021818</span>
              <span>座机电话：0571-88368111</span>
              <span>地址：浙江省杭州市西湖区同人精华A座1603</span>
            </li>
          </ul>
<!--          <img src="./assets/img/watererweima.png" alt />-->
        </div>
        <div class="copyright">
          <span>版权所有：浙江东太科技有限公司 <a style="color: white" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备08002626号-1</a></span>
          <span style="margin-left: 20px;margin-right: 2px;position: relative;top: 3px"><img style="width: 18px;" src="https://www.eastsun.net/eastsunImg/beian.png" alt=""></span>
          <span><a style="color: white" href="https://beian.mps.gov.cn/#/query/webSearch?code=33010602013568" rel="noreferrer" target="_blank">浙公网安备33010602013568</a></span>

        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false
    };
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    img {
      width: 100%;
      line-height: 60px;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 266px;
  overflow: hidden;
  background-color: #14679f;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    width: 100%;
    height: 100px;
    line-height: 60px;
    text-align: center;
    background:#13468d;
    span {
      color:white;
    }
  }
}
</style>
